import { AthosFetcher } from '../classes/athos-fetcher'
import { generateAthosProvider } from './provider'

export class AthosSuggest extends AthosFetcher {
  generateURL() {
    return super.generateURL('/suggest')
  }

  updateParams(options = {}) {
    const { query } = options

    this.params.set('language', 'en')
    this.params.set('suggestionCount', 4)
    this.params.set('productCount', 5)

    if (query) this.params.set('q', query)

    super.updateParams()
  }
}

export const AthosSuggestProvider = generateAthosProvider(AthosSuggest, (results) => {
  const alternatives = results?.alternatives || []
  return {
    ...results,
    items: alternatives.map((alternative) => ({
      query: alternative.text,
      label: alternative.text
    }))
  }
})
